import { render, staticRenderFns } from "./NursingTemplateList.vue?vue&type=template&id=e87a6d34&scoped=true"
import script from "./NursingTemplateList.vue?vue&type=script&lang=js"
export * from "./NursingTemplateList.vue?vue&type=script&lang=js"
import style0 from "./NursingTemplateList.vue?vue&type=style&index=0&id=e87a6d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87a6d34",
  null
  
)

export default component.exports